var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Spinner as BaseSpinner } from '../../spinner';
import { styled } from '../../styled';
import clsx from '../../utils/clsx';
import { tableLoadingStateClasses, getTableLoadingStateUtilityClass, tableLoadingStateComponentName, } from './table-loading-state-classes';
import { fade } from '../../styles/color-manipulator';
import { useMergedClasses } from '../../styles/classes';
var Root = styled('div', { name: tableLoadingStateComponentName, slot: 'Root' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return (__assign({ position: 'absolute', display: 'flex', top: 0, left: 0, width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', backgroundColor: fade(theme.tokens.color_bg_layer, 0.7) }, (ownerState.isEmpty && {
        position: 'initial',
        // this resolves the scorll bar showing in some scenarios while loading due to the spin
        minHeight: 100,
    })));
});
var Spinner = styled(BaseSpinner, { name: tableLoadingStateComponentName, slot: 'Spinner' })({});
export var TableLoadingState = React.forwardRef(function (props, ref) {
    var className = props.className, items = props.items, propClasses = props.classes, rootProps = __rest(props, ["className", "items", "classes"]);
    var classes = useMergedClasses(tableLoadingStateClasses, getTableLoadingStateUtilityClass, propClasses);
    var isEmpty = !(items && items.length);
    return (React.createElement(Root, __assign({ ref: ref, ownerState: { isEmpty: isEmpty }, className: clsx(classes.root, className) }, rootProps),
        React.createElement(Spinner, { className: classes.spinner, size: "medium" })));
});
